import { useEffect, useState } from 'react';

type PdfRenderer = {
  View: typeof import('@react-pdf/renderer').View | null;
  Image: typeof import('@react-pdf/renderer').Image | null;
  Text: typeof import('@react-pdf/renderer').Text | null;
  Document: typeof import('@react-pdf/renderer').Document | null;
  Page: typeof import('@react-pdf/renderer').Page | null;
  PDFViewer: typeof import('@react-pdf/renderer').PDFViewer | null;
  StyleSheet: typeof import('@react-pdf/renderer').StyleSheet | null;
  getStyleSheet: <T extends Record<string, any>>(factory: () => T) => T | null;
};

export function usePdfRenderer(): PdfRenderer {
  const [components, setComponents] = useState<
    Omit<PdfRenderer, 'getStyleSheet'>
  >({
    View: null,
    Image: null,
    Text: null,
    Document: null,
    Page: null,
    PDFViewer: null,
    StyleSheet: null,
  });

  useEffect(() => {
    let mounted = true;

    import('@react-pdf/renderer').then((mod) => {
      if (mounted) {
        setComponents({
          View: mod.View,
          Image: mod.Image,
          Text: mod.Text,
          Document: mod.Document,
          Page: mod.Page,
          PDFViewer: mod.PDFViewer,
          StyleSheet: mod.StyleSheet,
        });
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  const getStyleSheet = <T extends Record<string, any>>(
    factory: () => T
  ): T | null => {
    const StyleSheet = components.StyleSheet;
    return StyleSheet ? StyleSheet.create(factory()) : null;
  };

  return {
    ...components,
    getStyleSheet,
  };
}
